import React, { useState, useRef } from 'react';
import { css } from '@emotion/core';
import { Desktop, Tablet } from '../../constants/responsive';
import { useMount } from 'react-use';
import axios from 'axios';
import { useIntl } from 'gatsby-plugin-intl';
const dragDrop = require('drag-drop');

const Upload = ({
  name,
  required = false,
  setUploadingFlag,
  setReturnFilePath,
}) => {
  const [filename, setFilename] = useState('');
  const [showUploadInput, setShowUploadInput] = useState(true);
  const resumeInputRef = useRef();
  const resumeInputRefNotWeb = useRef();
  const letterInputRef = useRef();
  const letterInputRefNotWeb = useRef();
  const refMap = {
    resume: [resumeInputRef, resumeInputRefNotWeb],
    letter: [letterInputRef, letterInputRefNotWeb],
  };
  const [file, setFile] = useState(null);
  useMount(() => {
    initDragArea();
  });
  const fileTypeAndSizeCheck = (file, acceptType) => {
    let ext = file.name.split('.').pop();
    if (acceptType.includes(ext)) {
      if (file.size <= 5 * 1024 * 1024) {
        uploadFileHandler(file);
      } else {
        fileOverSizeTip(name);
      }
    }
  };

  const fileOverSizeTip = (name) => {
    let msgs = document.querySelectorAll(`.${name}-errMsg`);
    // IPAD、MOBILE
    msgs[0].innerText = {
      en: 'File over 5MB',
      'zh-cn': '文件超过5MB',
      'zh-hk': '文件超過5MB',
    }[intl.locale];
    // WEB
    msgs[1].innerText = {
      en: 'File over 5MB',
      'zh-cn': '文件超过5MB',
      'zh-hk': '文件超過5MB',
    }[intl.locale];
  };
  const initDragArea = () => {
    dragDrop(`#dropTarget${name}`, (files, pos, fileList, directories) => {
      let file = files[files.length - 1];
      fileTypeAndSizeCheck(file, ['pdf', 'doc', 'docx']);
    });
  };
  const uploadFileHandler = (file) => {
    setFilename(file.name);
    setShowUploadInput(false);
    setFile(file);
    uploadFile(file);
    setUploadingFlag(true);
  };
  const deleteFile = () => {
    setFilename('');
    // 删除文件，不仅是改变文件名字，还要清空文件
    let uploadInputs = document.querySelectorAll(`.${name}-upload`);
    [...uploadInputs].map((input) => {
      input.value = '';
    });
    setShowUploadInput(true);
  };
  const uploadFile = (file) => {
    const smarthkUrl = {
      live: 'https://smarthk.aqumon.com',
      test: 'https://test-smarthk.aqumon.com',
    }[process.env.GATSBY_ENV];
    let form = new FormData();
    form.append('multipartFile', file);
    // 将已上传的文件上传到指定路径
    if (file) {
      axios({
        method: 'post',
        url: `${smarthkUrl}/api/v4/front/file/upload`,
        params: {
          path: `notify_service/applicant_files`,
          name: `${new Date().getTime()}-${name}-${file.name}`,
        },
        data: form,
      })
        .then((res) => {
          // 向父组件传递上传的文件的路径
          if (res.data.status.ecode) {
            let errMsgs = document.querySelectorAll(`.${name}-errMsg`);
            errMsgs[0].innerText = {
              en: res.data.status.messageEN,
              'zh-cn': res.data.status.messageSC,
              'zh-hk': res.data.status.messageTC,
            }[intl.locale];
            errMsgs[1].innerText = {
              en: res.data.status.messageEN,
              'zh-cn': res.data.status.messageSC,
              'zh-hk': res.data.status.messageTC,
            }[intl.locale];
          } else {
            // 文件上传成功
            setReturnFilePath(res.data.data);
            setUploadingFlag(false);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };
  const intl = useIntl();
  return (
    <>
      {/* WEB端 */}
      <div>
        <h5
          css={css`
            span {
              color: #ee2f79;
            }
            color: #000000;
            margin: 0;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.29;
            margin-bottom: 5px;
            margin-right: 20px;
            ${Tablet} {
              margin-right: 20px;
              font-size: 18px;
              font-weight: 500;
              line-height: 1.11;
              margin-bottom: 0px;
            }
            ${Desktop} {
              margin-right: 16px;
              font-size: 16px;
              font-weight: 500;
              line-height: 1.25;
            }
          `}
        >
          {required && <span>*</span>}
          {intl.formatMessage({ id: `career.job.form.${name}` })}
        </h5>

        {/* 文件上传前UI - IPAD、MOBILE端 */}
        <h5
          css={css`
            display: ${showUploadInput ? 'inline-block' : 'none'};
            position: relative;
            color: #006eb1;
            margin: 0;
            font-size: 12px;
            font-weight: normal;
            line-height: 1.67;
            margin-bottom: 5px;
            ${Tablet} {
              font-size: 18px;
              font-weight: normal;
              line-height: 1.11;
              margin-bottom: 0px;
            }
            ${Desktop} {
              display: none;
            }
          `}
        >
          <input
            accept='.doc,.pdf,.docx'
            className={`${name}-upload`}
            name={name}
            type='file'
            css={css`
              position: absolute;
              width: 100%;
              height: 100%;
              opacity: 0;
            `}
            ref={refMap[name][1]}
            onChange={(e) => {
              let file = refMap[name][1].current.files[0];
              fileTypeAndSizeCheck(file, ['pdf', 'doc', 'docx']);
            }}
          />
          <span
            css={css`
              text-decoration: underline;
            `}
          >
            {intl.formatMessage({ id: `career.job.form.before-upload-tip` })}
          </span>
          {/* 错误提示  */}
          <span
            className={`${name}-errMsg`}
            css={css`
              text-decoration: none;
              color: #ee2f79;
              margin-left: 30px;
            `}
          ></span>
        </h5>
        {/* 文件未上传前的UI框 - WEB端 */}
        <h5
          css={css`
            display: none;
            ${Desktop} {
              display: ${showUploadInput ? 'inline-block' : 'none'};
              color: #006eb1;
              margin: 0;

              font-size: 16px;
              font-weight: normal;
              line-height: 1.25;
              margin-bottom: 30px;
            }
          `}
        >
          <span
            css={css`
              ${Desktop} {
                text-decoration: underline;
              }
            `}
          >
            {intl.formatMessage({ id: `career.job.form.before-upload-tip` })}
          </span>
          {/* 错误提示  */}
          <span
            className={`${name}-errMsg`}
            css={css`
              ${Desktop} {
                text-decoration: none;
                color: #ee2f79;
                margin-left: 30px;
              }
            `}
          ></span>
        </h5>

        <div
          id={`dropTarget${name}`}
          css={css`
            display: none;
            ${Desktop} {
              width: 798px;
              height: 371px;
              border: 3px dashed #e6e6e6;
              box-sizing: border-box;
              position: relative;
              display: ${showUploadInput ? 'block' : 'none'};
            }
          `}
        >
          {/* 文件拖拽上传提示文字 */}
          <div
            css={css`
              top: 0;
              width: 100%;
              height: 100%;
              position: absolute;
              text-align: center;
              padding-top: 100px;
              z-index: -1;
            `}
          >
            <h2
              css={css`
                color: #e5e5e5;
                margin: 0;
                ${Tablet} {
                }
                ${Desktop} {
                  font-size: 24px;
                  font-weight: normal;
                  line-height: 1.67;
                }
              `}
            >
              {intl.formatMessage({ id: `career.job.form.drag-drop` })}
            </h2>
            <br />
            <h4
              css={css`
                color: #e5e5e5;

                ${Tablet} {
                }
                ${Desktop} {
                  font-size: 20px;
                  font-weight: normal;
                  line-height: 2;
                }
              `}
            >
              {intl.formatMessage({ id: `career.job.form.or` })}
            </h4>
          </div>
          {/* 点击按钮 */}
          <div
            css={css`
              cursor: pointer;
              position: absolute;
              border-radius: 15px;
              background-color: #ee2f79;

              text-align: center;
              color: #ffffff;
              ${Tablet} {
              }
              ${Desktop} {
                width: 162px;
                height: 44px;
                top: 200px;
                left: 318px;

                font-size: 20px;
                font-weight: 500;
                line-height: 44px;
              }
            `}
          >
            <input
              className={`${name}-upload`}
              name={name}
              type='file'
              accept='.doc,.pdf,.docx'
              css={css`
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
                left: 0;
              `}
              ref={refMap[name][0]}
              onChange={(e) => {
                let file = refMap[name][0].current.files[0];
                fileTypeAndSizeCheck(file, ['pdf', 'doc', 'docx']);
              }}
            ></input>
            {intl.formatMessage({ id: `career.job.form.browse-files` })}
          </div>
        </div>
        {/* 文件上传后的UI */}
        <div
          css={css`
            display: ${showUploadInput ? 'none' : 'inline-block'};
            width: auto;
            padding: 8px 15px;
            height: 39px;
            border-radius: 10px;
            background-color: #f8f8f8;
            ${Tablet} {
            }
            ${Desktop} {
              width: auto;
              padding: 8px 15px;
              height: 39px;

              border-radius: 10px;
              background-color: #f8f8f8;
            }
          `}
        >
          <div
            css={css`
              display: flex;
              justify-content: center;
              align-items: center;
            `}
          >
            <span
              className={`${name}-uploadFileName`}
              css={css`
                font-size: 16px;
                font-weight: normal;
                line-height: 1.25;
                color: #006eb1;
              `}
            >
              {filename}
            </span>
            <span
              css={css`
                width: 10px;
              `}
            ></span>
            <img
              src={`/career/career-delete-icon.png`}
              css={css`
                width: 15px;
                height: 15px;
              `}
              onClick={deleteFile}
            ></img>
          </div>
        </div>
      </div>
    </>
  );
};
export default Upload;
